const pulseRadius = radius => ({
  borderTopLeftRadius: radius,
  borderTopRightRadius: radius,
  borderBottomLeftRadius: radius,
  borderBottomRightRadius: radius,
})

const pulseCheckmarkBorderColor = ($theme, $checked, error) => {
  if ($checked) return $theme.colors.primaryPulse
  if (error) return $theme.colors.dangerPulse
  return $theme.colors.borderPulseHover
}

const pulseLabelColor = ($theme, $disabled, error) => {
  if ($disabled) return $theme.colors.textPulseFaint
  if (error) return $theme.colors.dangerPulseText
  return $theme.colors.textPulseStrong
}

export const SDCheckboxPulseOverrides = error => ({
  Root: {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      alignSelf: 'flex-start',
      ':not(:last-child)': {
        marginBottom: '10px',
      },
    },
  },
  Checkmark: {
    style: ({ $theme, $checked }) => ({
      width: '18px',
      height: '18px',
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      backgroundSize: '12px',
      borderTopWidth: '1.5px',
      borderBottomWidth: '1.5px',
      borderLeftWidth: '1.5px',
      borderRightWidth: '1.5px',
      borderTopColor: pulseCheckmarkBorderColor($theme, $checked, error),
      borderBottomColor: pulseCheckmarkBorderColor($theme, $checked, error),
      borderLeftColor: pulseCheckmarkBorderColor($theme, $checked, error),
      borderRightColor: pulseCheckmarkBorderColor($theme, $checked, error),
      ...pulseRadius('5px'),
    }),
  },
  ToggleTrack: {
    style: ({ $theme, $checked, $disabled }) => ({
      width: '40px',
      height: '22px',
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: '3px',
      paddingRight: '3px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: $checked ? 'flex-end' : 'flex-start',
      ...pulseRadius('11px'),
      backgroundColor: $disabled
        ? $theme.colors.bgPulseTrack
        : $checked
          ? $theme.colors.primaryPulse
          : $theme.colors.borderPulse,
    }),
  },
  Toggle: {
    style: ({ $theme }) => ({
      width: '16px',
      height: '16px',
      // The track's justifyContent places the thumb; BaseUI's own translateX would push it onto the label.
      transform: 'none',
      backgroundColor: $theme.colors.white,
      boxShadow: $theme.lighting.shadowPulseThumb,
      ...pulseRadius('9999px'),
    }),
  },
  Label: {
    style: ({ $theme, $disabled }) => ({
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      marginTop: 0,
      paddingLeft: 0,
      paddingRight: 0,
      color: pulseLabelColor($theme, $disabled, error),
    }),
  },
})

export const SDCheckboxOverrides = error => ({
  Root: {
    style: ({ $theme }) => ({
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0.5rem',
      alignSelf: 'stretch',
      ':not(:last-child)': {
        marginBottom: '1rem',
      },
    }),
  },
  Checkmark: {
    style: ({ $theme }) => ({
      backgroundSize: 'auto',
      border: error ? `solid 2px ${$theme.colors.borderErrorPink}` : `solid 1px ${$theme.colors.borderInput}`,
      borderRadius: '8px 8px',
      width: '2rem',
      height: '2rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: 0,
    }),
  },
  Label: {
    style: ({ $theme }) => ({
      flex: '1 0 0',
      display: 'flex',
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '1.6rem',
      letterSpacing: '-0.011rem',
      marginTop: '0.25rem',
      paddingLeft: 0,
      color: error ? $theme.colors.errorTextAlt : $theme.colors.contentPrimary,
    }),
  },
})
